import { type ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-[var(--color-rule)] bg-[var(--color-paper)] px-4 py-12 text-center shadow-[var(--shadow-brutal-sm)]">
      {icon && <div className="mb-3 text-[var(--color-subtle)]">{icon}</div>}
      <h3 className="text-sm font-semibold text-[var(--color-ink)]">{title}</h3>
      {description && <p className="mt-1 text-sm font-medium text-[var(--color-muted)]">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
